import { atom } from 'recoil';
import { getBrowserLocale } from 'utils/locales';
import { SupportedLocales, TenantInfo } from './types';

export const applicationLanguageState = atom<SupportedLocales>({
  key: 'applicationLanguage',
  default: getBrowserLocale(),
});

export const tenantInfoState = atom<TenantInfo>({
  key: 'tenantInfo',
  default: undefined
});